import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux/actions';
import { Headline, ErrorBox } from '../../components/text';
import { LoadingSpinner, LoadingIndicator } from '../../components/loaders';
import { Page, Box, Separator, CenterContainer, Stack } from '../../components/containers';
import { Button, ButtonRounded } from '../../components/actions';
import { Checkbox } from '../../components/fields';
import { fetchUserData, updateOrCreateUser } from './action';
import { USER_TYPE } from '../../constants';
import { ADMIN_USER_FORM_STATUS } from './constants';
import { PAGE_ADMIN } from '../../App';
import { getReportsCategoriesList } from '../ReportsPage/action';
import { getIsReportsListLoading, getHasReportsListFetchFailed, getReportsList } from '../../selectors';
import s from './index.css';

const mapStateToProps = state => ({
    isReportsListLoading: getIsReportsListLoading(state),
    hasReportsListFetchFailed: getHasReportsListFetchFailed(state),
    reportsListData: getReportsList(state),
});

class AdminUserFormPage extends React.Component {
    state = {
        isUrlWrong: false,
        userId: null,
        newUser: false,
        loading: false,
        fetchError: false,
        status: ADMIN_USER_FORM_STATUS.None,
        fields: {
            name: '',
            email: '',
            userType: USER_TYPE.Customer,
            generatePassword: true,
            isActive: true,
            allowedReports: [],
        },
    };

    componentDidMount() {
        this.props.dispatch(getReportsCategoriesList());

        this.initializeUser(
            this.props.match && this.props.match.params && this.props.match.params.id ? this.props.match.params.id : ''
        );
    }

    componentWillReceiveProps(nextProps) {
        if (
            this.props.match &&
            nextProps.match &&
            this.props.match.params &&
            nextProps.match.params &&
            this.props.match.params.id !== nextProps.match.params.id
        ) {
            this.initializeUser(nextProps.match.params.id);
        }
    }

    render() {
        return (
            <Page>
                <div className={s.wrapper}>
                    <div className={s.header}>
                        <Headline size="small">{this.state.newUser ? 'Create user' : 'Edit user'}</Headline>
                        <LoadingIndicator label="Loading user" show={this.state.loading} labelOnRight={true} />
                    </div>

                    <Separator type="narrow" />

                    {(this.state.isUrlWrong && (
                        <ErrorBox
                            onClick={this.handleGoingBackToUsersList}
                            label={
                                'User does not exist, ' +
                                'click here to go back to users list or use form below to create new user'
                            }
                            noTopMargin={true}
                        />
                    )) ||
                        (this.state.fetchError && (
                            <ErrorBox
                                onClick={this.handleRefetching}
                                label="Could not fetch user data, click here to try again"
                                noTopMargin={true}
                            />
                        ))}

                    <Box>
                        <div className={s.form}>
                            <Stack className={s.row}>
                                <label>
                                    <p>Full name</p>
                                    <input
                                        onChange={this.handleNameChange}
                                        type="text"
                                        placeholder="User full name is required"
                                        value={this.state.fields.name}
                                    />
                                </label>

                                <label>
                                    <p>Email address</p>
                                    <input
                                        onChange={this.handleEmailChange}
                                        type="email"
                                        placeholder="User email is required"
                                        value={this.state.fields.email}
                                    />
                                </label>
                            </Stack>

                            <Stack className={s.row}>
                                <label>
                                    <p>User type</p>
                                    <select onChange={this.handleUserTypeChange} value={this.state.fields.userType}>
                                        {Object.keys(USER_TYPE).map(key => {
                                            const typeId = USER_TYPE[key];
                                            const type =
                                                typeId === USER_TYPE.Admin ? 'Administrator' : 'Reports portal user';
                                            return (
                                                <option key={typeId} value={typeId}>
                                                    {type}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </label>

                                <label>
                                    <p>Account status</p>
                                    <select
                                        onChange={this.handleUserStatusChange}
                                        value={this.state.fields.isActive ? 1 : 0}
                                    >
                                        <option value={1}>Enabled</option>
                                        <option value={0}>Disabled</option>
                                    </select>
                                </label>
                            </Stack>
                        </div>
                    </Box>

                    {this.state.fields.userType === USER_TYPE.Customer && this.props.hasReportsListFetchFailed && (
                        <ErrorBox
                            onClick={this.handleRefetchReportTypes}
                            label="Could not load report types, click here to try again"
                        />
                    )}

                    {this.state.fields.userType === USER_TYPE.Customer &&
                        this.props.hasReportsListFetchFailed === false &&
                        this.props.reportsListData && (
                            <Box addPadding={this.props.isReportsListLoading}>
                                <p className={s.title}>Reports permissions</p>

                                {(this.props.isReportsListLoading && (
                                    <LoadingIndicator
                                        className={s.reportsLoader}
                                        label="Loading reports list"
                                        show={true}
                                    />
                                )) || (
                                    <div className={s.permissions}>
                                        {this.props.reportsListData.map(report => {
                                            const isChecked =
                                                this.state.fields.allowedReports.indexOf(report.reportId) !== -1;

                                            return (
                                                <div key={report.reportId}>
                                                    <Checkbox
                                                        onChange={this.handlePermissionToggle(report.reportId)}
                                                        checked={isChecked}
                                                        label={report.repTitle}
                                                        labelOnLeft={false}
                                                    />
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </Box>
                        )}

                    <Box addPadding={true} addShadow={true}>
                        <Stack>
                            <div>
                                <Checkbox
                                    onChange={this.handleGeneratePasswordToggle}
                                    checked={this.state.fields.generatePassword}
                                    label={
                                        this.state.newUser
                                            ? 'Send password to user email'
                                            : 'Reset user password and send it to user email'
                                    }
                                    labelOnLeft={false}
                                />
                            </div>

                            <div>
                                <ButtonRounded
                                    onClick={this.handleSave}
                                    align="right"
                                    design={
                                        this.state.status > 0 ? 'default' : this.state.status < 0 ? 'warning' : 'filled'
                                    }
                                    label={
                                        this.state.status === ADMIN_USER_FORM_STATUS.Saving
                                            ? 'Saving...'
                                            : this.state.status === ADMIN_USER_FORM_STATUS.Success
                                            ? 'Changes saved'
                                            : this.state.status === ADMIN_USER_FORM_STATUS.ErrorEmailIsRequired
                                            ? 'Email address is required'
                                            : this.state.status === ADMIN_USER_FORM_STATUS.ErrorNameIsRequired
                                            ? 'Full name is required'
                                            : this.state.status < 0
                                            ? 'Could not save, try again'
                                            : 'Save changes'
                                    }
                                />
                            </div>
                        </Stack>
                    </Box>

                    {this.state.loading && (
                        <CenterContainer>
                            <LoadingSpinner />
                        </CenterContainer>
                    )}
                </div>
            </Page>
        );
    }

    handleNameChange = e => {
        const value = e.target.value;
        this.setState(oldState => ({
            ...oldState,
            fields: {
                ...oldState.fields,
                name: value,
            },
        }));
    };

    handleEmailChange = e => {
        const value = e.target.value;
        this.setState(oldState => ({
            ...oldState,
            fields: {
                ...oldState.fields,
                email: value,
            },
        }));
    };

    handleUserTypeChange = e => {
        const value = parseInt(e.target.value, 10);
        this.setState(oldState => ({
            ...oldState,
            fields: {
                ...oldState.fields,
                userType: value,
            },
        }));
    };

    handleUserStatusChange = e => {
        const value = parseInt(e.target.value, 10);
        this.setState(oldState => ({
            ...oldState,
            fields: {
                ...oldState.fields,
                isActive: value === 1 ? true : false,
                generatePassword:
                    value === 1 ? (this.state.newUser ? true : this.state.fields.generatePassword) : false,
                // Do not send password email to user when account is disabled
            },
        }));
    };

    handlePermissionToggle = reportId => checked => {
        this.setState(oldState => {
            const reportIndex = oldState.fields.allowedReports.indexOf(reportId);

            return {
                ...oldState,
                fields: {
                    ...oldState.fields,
                    allowedReports:
                        reportIndex === -1
                            ? [...oldState.fields.allowedReports, reportId]
                            : [
                                  ...oldState.fields.allowedReports.slice(0, reportIndex),
                                  ...oldState.fields.allowedReports.slice(reportIndex + 1),
                              ],
                },
            };
        });
    };

    handleGeneratePasswordToggle = checked => {
        this.setState(oldState => ({
            ...oldState,
            fields: {
                ...oldState.fields,
                generatePassword: this.state.newUser ? true : checked,
            },
        }));
    };

    handleGoingBackToUsersList = e => {
        this.props.dispatch(push(PAGE_ADMIN.Users));
    };

    handleRefetching = e => {
        this.initializeUser(
            this.props.match && this.props.match.params && this.props.match.params.id ? this.props.match.params.id : ''
        );
    };

    initializeUser = urlId => {
        // Verify URL content
        const urlIdAsNumber = parseInt(urlId, 10);
        if (urlId !== 'new' && isNaN(urlIdAsNumber)) {
            this.setState({
                isUrlWrong: true,
                loading: false,
                fetchError: false,
            });
            return false;
        }

        if (urlId === 'new') {
            this.setState({
                isUrlWrong: false,
                userId: null,
                newUser: true,
                loading: false,
                fetchError: false,
                fields: {
                    name: '',
                    email: '',
                    userType: USER_TYPE.Customer,
                    generatePassword: true,
                    isActive: true,
                    allowedReports: [],
                },
            });
            return true;
        }

        this.setState({
            isUrlWrong: false,
            userId: urlIdAsNumber,
            newUser: false,
            loading: true,
            fetchError: false,
            status: ADMIN_USER_FORM_STATUS.None,
        });

        this.props
            .dispatch(fetchUserData(urlIdAsNumber))
            .then(user => {
                const userType = Object.values(USER_TYPE).find(typeId => {
                    return typeId === user.typeId;
                });

                this.setState(oldState => ({
                    ...oldState,
                    loading: false,
                    fields: {
                        ...oldState.fields,
                        name: user.name,
                        email: user.email,
                        userType: typeof userType === 'number' ? userType : USER_TYPE.Customer,
                        generatePassword: false,
                        isActive: user.status ? true : false,
                        allowedReports:
                            typeof user.allowedReports === 'string'
                                ? user.allowedReports.indexOf(',') === -1
                                    ? [parseInt(user.allowedReports, 10)]
                                    : user.allowedReports.slice(',').map(reportId => parseInt(reportId, 10))
                                : [],
                    },
                }));
            })
            .catch(error => {
                if (error.response && error.response.status && error.response.status === 404) {
                    this.setState({
                        isUrlWrong: true,
                        loading: false,
                    });
                } else {
                }
            });
    };

    handleSave = e => {
        if (this.state.fields.name.trim() === '') {
            this.setState({
                status: ADMIN_USER_FORM_STATUS.ErrorNameIsRequired,
            });
            return false;
        }

        if (this.state.fields.email.trim() === '' || this.state.fields.email.indexOf('@') === -1) {
            this.setState({
                status: ADMIN_USER_FORM_STATUS.ErrorEmailIsRequired,
            });
            return false;
        }

        this.setState({
            status: ADMIN_USER_FORM_STATUS.Saving,
        });

        this.props
            .dispatch(
                updateOrCreateUser(
                    this.state.newUser || this.state.userId === null ? null : this.state.userId,
                    this.state.fields.name,
                    this.state.fields.email,
                    this.state.fields.userType,
                    this.state.fields.allowedReports,
                    this.state.fields.isActive,
                    this.state.fields.generatePassword
                )
            )
            .then(response => {
                const userId = response.data.id;

                this.setState(
                    {
                        status: ADMIN_USER_FORM_STATUS.Success,
                    },
                    () => {
                        if (this.state.newUser) {
                            this.setState(oldState => ({
                                ...oldState,
                                userId: userId,
                                newUser: false,
                                fields: {
                                    ...oldState.fields,
                                    generatePassword: false,
                                },
                            }));
                        }

                        setTimeout(() => {
                            if (this.state.status === ADMIN_USER_FORM_STATUS.Success) {
                                this.setState({
                                    status: ADMIN_USER_FORM_STATUS.None,
                                });

                                if (window.location.pathname.includes('/new')) {
                                    window.history.pushState(
                                        '',
                                        '',
                                        window.location.pathname.replace('/new', '/' + userId)
                                    );
                                }
                            }
                        }, 2000);
                    }
                );
            })
            .catch(error => {
                console.error('Could not save user changes: ', error);
                this.setState({
                    status: ADMIN_USER_FORM_STATUS.Error,
                });
            });
    };

    handleRefetchReportTypes = e => {
        this.props.dispatch(getReportsCategoriesList(true));
    };
}

export default connect(mapStateToProps)(AdminUserFormPage);



// WEBPACK FOOTER //
// ./app/web/src/container/AdminUserForm/index.jsx